import Rest from "../../../class/tool/Rest";
import Notification from "./Notification";

class NotificationController {
    #_rest = new Rest();
    _callback = null;
    _baseURL = "notifications";

    index() {
        this.#_rest.sendQuery(
            'GET',
            '/' + this._baseURL,
            {},
            this.handleIndex);
    }
    handleIndex = (response, error, status = 200) => {
        let listObjects = []
        let pagination = null

        if(status === 200) {
            let data

            if (response.data !== undefined && response.data.data !== undefined) {
                if(response.data.total !== undefined) {
                    pagination = {
                        total: response.data.total,
                        from: response.data.from != null ? response.data.from : 0,
                        to: response.data.to != null ? response.data.to : 0,
                        per_page: response.data.per_page,
                        current_page: response.data.current_page,
                        first_page_url: new URL(response.data.first_page_url).search,
                        last_page_url: new URL(response.data.last_page_url).search,
                        next_page_url: response.data.next_page_url !== null ? new URL(response.data.next_page_url).search : null,
                        prev_page_url: response.data.prev_page_url !== null ? new URL(response.data.prev_page_url).search : null
                    }
                }

                data = response.data.data
            }
            else if (response.data)
                data = response.data

            for(let item in data)
                listObjects.push(new Notification(data[item]))
        }

        if (this._callback !== null)
            this._callback(listObjects, error, pagination, status)
    }

    read (id) {
        this.#_rest.sendQuery(
            'POST',
            '/' + this._baseURL + "/" + id + "/read",
            {},
            this.handleRead);
    }
    handleRead = (response, error, status = 200) => {
        if (this._callback !== null)
            this._callback(error, status);
    }

    readAll () {
        this.#_rest.sendQuery(
            'POST',
            '/' + this._baseURL + "/read",
            {},
            this.handleReadAll);
    }
    handleReadAll = (response, error, status = 200) => {
        if (this._callback !== null)
            this._callback(error, status);
    }

    subscribe (endpoint) {
        this.#_rest.sendQuery(
            'POST',
            "/subscribe",
            {
                "endPoint": endpoint
            },
            this.handleSubscribe);
    }
    handleSubscribe = (response, error, status = 200) => {
        if (this._callback !== null)
            this._callback(error, status);
    }

    unsubscribe (endpoint) {
        this.#_rest.sendQuery(
            'POST',
            "/unsubscribe",
            {
                "endPoint": endpoint
            },
            this.handleUnubscribe);
    }
    handleUnubscribe = (response, error, status = 200) => {
        if (this._callback !== null)
            this._callback(error, status);
    }
}

export default NotificationController;